import {Action} from '@ngrx/store';

export const PAGE_STATE_RESET = '[AktionenPage] State reset';
export const TOGGEL_AKTION_ACTION = '[AktionenPage] Toggle Aktionen';


export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

export class ToggleAktionAction implements Action {
    readonly type = TOGGEL_AKTION_ACTION;

    constructor(public aktionId: string) {
    }
}


export type Actions =
    PageStateResetAction
    | ToggleAktionAction
    ;
